import { useEffect } from "react";
import { Box, ListItemText, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Layout, useUserStore } from "@roc/feature-app-core";
import { Paper, GridColumnProps, Tabs, Tab } from "@roc/ui";
import { observer } from "mobx-react";
import { filterProps, noOpComparator } from "@roc/ui/utils";
import { useLoanVendorStore } from "../../hooks/userLoanVendorStore";
import { LoanVendorsGrid } from "./loanVendorsGrid";
import { LoanVendorToolbar } from "./loanVendorToolbar";
import { CounterPartyExpensesTab, getLoanVendorTabs } from "../../types/types";
import { CreateVendorForm } from "../loanVendor/createVendorForm";
import { BankInformationApproval } from "../loanVendor/bankInformationApproval";
import { CreateVendorUserForm } from "../loanVendor/createVendorUserForm";

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: "1400px",
  },
  paper: {
    boxShadow: "none !important",
    border: "1px solid #cdcdcd",
    padding: "0px",
    borderRadius: "0 !important",
  },
}));

export const LoanVendorDashboard = observer(({ }) => {
  const classes = useStyles();
  const { loanVendorStore } = useLoanVendorStore();
  const { selectedTab, globalStore } = loanVendorStore;
  const { userStore } = useUserStore();
  const loanVendorTabsFiltered = getLoanVendorTabs(globalStore.userFeatures).filter(t => !t.hidden).map(t => ({ label: t.label, value: t.value }));
  const selectedTabIndex = loanVendorTabsFiltered.findIndex(t => t.value == selectedTab)

  useEffect(() => {
    userStore.getUserInfoAndEntitlements();
  }, [])

  useEffect(() => {
    if (loanVendorStore.loanVendor && selectedTab === CounterPartyExpensesTab.VENDOR_LOANS) {
      loanVendorStore.gridStore.fetchGridData();
    }
  }, [loanVendorStore.loanVendor]);

  const actions = (record, handleMenuClose) => {
    return [
      <MenuItem
        onClick={() => {
          const loanVendor = {
            loanId: loanVendorStore?.loan?.loanId,
            loanVendorId: record?.loanVendorId,
            servicingVendorId: record?.servicingVendorId,
          };
          loanVendorStore.removeLoanVendor(loanVendor);
          handleMenuClose();
        }}
      >
        <ListItemText>Remove</ListItemText>
      </MenuItem>,
    ];
  };

  const COLUMNS: GridColumnProps[] = [
    {
      field: "loanId",
      headerName: "Loan Id",
      maxWidth: 100,
      comparator: noOpComparator,
      ...filterProps(),
    },
    {
      field: "dealName",
      headerName: "Deal Name",
      minWidth: 125,
      comparator: noOpComparator,
      ...filterProps(),
    },
    {
      field: "lenderName",
      headerName: "Lender Name",
      minWidth: 125,
      comparator: noOpComparator,
      ...filterProps(),
    },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 125,
      cellRenderer: "currencyCellRenderer",
      comparator: noOpComparator,
      ...filterProps(),
    },
    {
      field: "status",
      headerName: "Loan Status",
      minWidth: 125,
      comparator: noOpComparator,
      ...filterProps(),
    },
    {
      field: "servicingVendorId",
      headerName: "Action",
      minWidth: 80,
      cellRenderer: "actionCellRenderer",
      comparator: noOpComparator,
      width: 80,
      pinned: "right",
      lockPinned: true,
    },
    {
      field: "loanVendorId",
      headerName: "Loan Vendor Id",
      minWidth: 80,
      comparator: noOpComparator,
      width: 80,
      pinned: "right",
      lockPinned: true,
      hide: true,
    },
  ];



  const getTabOptions = () => {
    switch (loanVendorTabsFiltered[selectedTabIndex]?.value) {
      case CounterPartyExpensesTab.VENDOR_LOANS:
        return <LoanVendorsGrid
          store={loanVendorStore}
          columns={COLUMNS}
          selectModeEnabled={false}
          actions={actions}
          toolbar={<LoanVendorToolbar />}
        />;
      case CounterPartyExpensesTab.VENDOR_CREATE_VENDORS:
        return <CreateVendorForm />;
      case CounterPartyExpensesTab.VENDOR_APPROVAL:
        return <BankInformationApproval />;
      case CounterPartyExpensesTab.VENDOR_USERS:
        return <CreateVendorUserForm />;
    }
  };

  return (
    <Layout title={`Vendors`} containerClass={classes.container}>
      <Box pb={2}>
        <Tabs
          selectedTab={selectedTabIndex}
          tabs={Object.values(loanVendorTabsFiltered)}
          onTabChange={(e, i) => {
            loanVendorStore.setSelectedTab(loanVendorTabsFiltered[i]?.value)
            loanVendorStore.reset();
          }}
        />
      </Box>
      <Box display="flex" flexDirection="column" height="100%">
        <Box flex={1}>
          <Paper className={classes.paper}>
            {getTabOptions()}
          </Paper>
        </Box>
      </Box>
    </Layout>
  );
});
